// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coloring-app {
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  font-family: "Golos Text", Arial, sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-header {
  display: flex;
  align-items: center;
  height: 72px;
  flex-shrink: 0;
}

.coloring-app h1 {
  margin: 0;
  padding: 15px 0;
  color: white;
  font-size: 24px;
  flex: 1;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.header-actions-flex {
  display: flex;
  gap: 16px;
  align-items: center;
}
.header-actions-flex:nth-child(2) {
  margin-right: 3vw;
}

.header-icon-button {
  border: 1px solid #DBDBDB;
  padding: 8px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: #000;
  font-size: 12px;
}
.header-icon-button-long {
  font-weight: 600;
  padding: 4px 16px;
}
.header-icon-button-long svg {
  margin-right: 4px;
  width: 18px;
  height: 18px;
}

.header-icon-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.header-icon-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.header-icon-button:active:not(:disabled) {
  transform: translateY(0);
}

.app-layout {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.logo {
  margin-right: 7vw;
  margin-left: 5vw;
}

/* Левая панель инструментов */
.left-sidebar {
  width: 312px;
  min-width: 312px;
  background: #f5f5f5;
  border-right: 2px solid #ddd;
  overflow-y: auto;
  overflow-x: hidden;
}

.toolbar {
  padding: 15px;
}

.tool-section {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ddd;
}

.tool-section-margin {
  width: 100%;
  height: 1px;
  margin-bottom: 15px;
}

.tool-section:last-child {
  border-bottom: none;
}

.tool-section h3 {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: bold;
  color: #494949;
}

.tool-buttons {
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-wrap: wrap;
  color: #000;
  font-weight: bold;
}

.tool-buttons button {
  padding: 5px 5px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  font-size: 12px;
  text-transform: uppercase;
  flex-basis: calc(50% - 2px);
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-buttons button svg {
  margin-right: 5px;
}

.tool-buttons button:hover {
  border-color: #DA563A;
}

.tool-buttons button.active {  
  border-color: #DA563A;
}

/* История действий */
.history-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.history-buttons button {
  padding: 10px 15px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
}

.history-buttons button:hover:not(:disabled) {
  background: #e9e9e9;
}

.history-buttons button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Переключатель курсора */
.cursor-type-buttons {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.cursor-type-buttons button {
  padding: 10px 15px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  text-align: center;
  flex-basis: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}
.cursor-type-buttons button svg {
  margin-right: 10px;
}
.cursor-type-buttons button:hover {
  background: #e9e9e9;
}

.cursor-type-buttons button.active {
  border-color: #DA563A;
}

/* Палитра цветов */
.color-picker-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Текущий выбранный цвет */
.current-color-display {
  width: 30px;
  height: 30px;
  display: block;
  position: relative;
  border-radius: 50%;
}

.current-color-display .color-hex {
  display: none !important;
}

/* Стандартная палитра (как в браузере) - всегда открыта */
.standard-color-picker {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.color-palette {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  margin-top: 8px;
}

.palette-color {
  width: 100%;
  aspect-ratio: 1;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.15s;
  padding: 0;
  min-height: 24px;
  position: relative;
}

.palette-color:hover {
  transform: scale(1.1);
  border-color: #DA563A;
  box-shadow: 0 2px 6px rgba(0, 123, 255, 0.3);
  z-index: 1;
}

.palette-color.active {
  border-color: #DA563A;
  border-width: 2px;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.hue-slider-container {
  width: 100%;
  position: relative;
  margin: 8px 0;
}

.hue-slider {
  width: 100%;
  height: 20px;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 10px;
  border: 1px solid #ccc;
  cursor: pointer;
  background: linear-gradient(to right, 
    #ff0000 0%, #ffff00 17%, #00ff00 33%, 
    #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);
}

.hue-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  border: 2px solid #333;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.hue-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  border: 2px solid #333;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.sv-picker {
  width: 100%;
  height: 230px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: crosshair;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%, 100% 100%;
  background-position: 0 0, 0 0;
  background-repeat: no-repeat;
}

.sv-picker-indicator {
  position: absolute;
  width: 14px;
  height: 14px;
  border: 2px solid white;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3);
}

.color-picker-footer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hex-input-container {
  flex: 1;
}

.hex-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
  text-align: center;
  text-transform: uppercase;
  background: #f8f8f8;
}

.hex-input:focus {
  outline: none;
  border-color: #DA563A;
  background: white;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.eyedropper-button {
  width: 36px;
  height: 36px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  color: #333;
}

.eyedropper-button:hover {
  background: #f0f0f0;
  border-color: #999;
}

.eyedropper-button:active {
  background: #e0e0e0;
  transform: scale(0.95);
}

.eyedropper-button svg {
  width: 100%;
  height: 100%;
}

/* Размер инструментов */
.size-control {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.size-control input[type="range"] {
  width: 100%;
}

.size-control span {
  text-align: center;
  font-size: 12px;
  color: #666;
}

/* Масштаб */
.zoom-control {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.zoom-control input[type="range"] {
  width: 100%;
}

.zoom-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.zoom-info span {
  font-size: 12px;
  color: #666;
}

.zoom-info button {
  padding: 5px 10px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.zoom-info button:hover:not(:disabled) {
  background: #e9e9e9;
}

.zoom-info button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Действия */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.upload-button {
  display: block;
  padding: 12px 15px;
  background: #28a745;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  transition: background 0.2s;
  font-size: 14px;
  border: none;
}

.upload-button:hover {
  background: #218838;
}

.action-buttons button {
  padding: 12px 15px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 14px;
  text-align: left;
}

.action-buttons button:hover:not(:disabled) {
  background: #e9e9e9;
}

.action-buttons button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Область canvas */
.canvas-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #e9ecef;
}

.instructions {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  flex-shrink: 0;
  border-left: 1px solid #DBDBDB;
  margin:0 2vw;
}
.instructions-block {
  padding: 10px 1.5vw;
  border-right: 1px solid #DBDBDB;
  color: #999;
}
.instructions-block span {
  color: #000;
}

.canvas-container {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  background: #f0f0f0;
}

.canvas-container canvas {
  display: block;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #ccc;
  /* Размеры canvas устанавливаются программно, CSS не должен их изменять */
}

.placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 18px;
  text-align: center;
  pointer-events: auto;
  background: rgba(255, 255, 255, 0.95);
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  border: 2px dashed #DA563A;
}

.placeholder:hover {
  background: rgba(255, 255, 255, 1);
  border-color: #0056b3;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);
  transform: translate(-50%, -50%) scale(1.02);
}

.custom-slider {
  -webkit-appearance: none;
  appearance: none;
  background: transparent; /* Remove default background */
  width: 100%;
}
.custom-slider::-webkit-slider-runnable-track {
  background: #ddd; /* Color of the track */
  height: 8px;
  border-radius: 4px;
}
.custom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: 20px;
  width: 20px;
  border-radius: 50%; /* Circular thumb */
  background: #DA563A; /* Color of the thumb */
  cursor: pointer;
  margin-top: -6px; /* Center the thumb vertically */
}

/* Mozilla Firefox */
.custom-slider::-moz-range-track {
  background: #ddd; /* Color of the track */
  height: 8px;
  border-radius: 4px;
}

.custom-slider::-moz-range-thumb {
  height: 20px;
  width: 20px;
  border-radius: 50%; /* Circular thumb */
  background: #DA563A; /* Color of the thumb */
  cursor: pointer;
}

/* Адаптивность */
@media (max-width: 768px) {
  .app-layout {
    flex-direction: column;
  }

  .left-sidebar {
    width: 100%;
    min-width: 100%;
    max-height: 50vh;
    border-right: none;
    border-bottom: 2px solid #ddd;
  }

  .toolbar {
    padding: 10px;
  }

  .tool-buttons {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .tool-buttons button {
    flex: 1;
    min-width: 100px;
  }

  .color-palette {
    grid-template-columns: repeat(10, 1fr);
  }

  .action-buttons {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .action-buttons button,
  .upload-button {
    flex: 1;
    min-width: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ColoringApp.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;EACZ,eAAe;EACf,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf;;wDAEsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yCAAyC;EACzC,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB,EAAE,8BAA8B;EACvD,WAAW;AACb;AACA;EACE,gBAAgB,EAAE,uBAAuB;EACzC,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAE,mBAAmB;EACvC,mBAAmB,EAAE,uBAAuB;EAC5C,eAAe;EACf,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA,oBAAoB;AACpB;EACE,gBAAgB,EAAE,uBAAuB;EACzC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB,EAAE,mBAAmB;EACvC,mBAAmB,EAAE,uBAAuB;EAC5C,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;IAEE,OAAO;IACP,gBAAgB;EAClB;AACF","sourcesContent":[".coloring-app {\n  width: 100%;\n  height: 100vh;\n  max-height: 100vh;\n  margin: 0;\n  padding: 0;\n  font-family: \"Golos Text\", Arial, sans-serif;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  height: 72px;\n  flex-shrink: 0;\n}\n\n.coloring-app h1 {\n  margin: 0;\n  padding: 15px 0;\n  color: white;\n  font-size: 24px;\n  flex: 1;\n}\n\n.header-actions {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.header-actions-flex {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n.header-actions-flex:nth-child(2) {\n  margin-right: 3vw;\n}\n\n.header-icon-button {\n  border: 1px solid #DBDBDB;\n  padding: 8px;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  color: #000;\n  font-size: 12px;\n}\n.header-icon-button-long {\n  font-weight: 600;\n  padding: 4px 16px;\n}\n.header-icon-button-long svg {\n  margin-right: 4px;\n  width: 18px;\n  height: 18px;\n}\n\n.header-icon-button:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.header-icon-button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.header-icon-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.app-layout {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.logo {\n  margin-right: 7vw;\n  margin-left: 5vw;\n}\n\n/* Левая панель инструментов */\n.left-sidebar {\n  width: 312px;\n  min-width: 312px;\n  background: #f5f5f5;\n  border-right: 2px solid #ddd;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.toolbar {\n  padding: 15px;\n}\n\n.tool-section {\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #ddd;\n}\n\n.tool-section-margin {\n  width: 100%;\n  height: 1px;\n  margin-bottom: 15px;\n}\n\n.tool-section:last-child {\n  border-bottom: none;\n}\n\n.tool-section h3 {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #494949;\n}\n\n.tool-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  flex-wrap: wrap;\n  color: #000;\n  font-weight: bold;\n}\n\n.tool-buttons button {\n  padding: 5px 5px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n  font-size: 12px;\n  text-transform: uppercase;\n  flex-basis: calc(50% - 2px);\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tool-buttons button svg {\n  margin-right: 5px;\n}\n\n.tool-buttons button:hover {\n  border-color: #DA563A;\n}\n\n.tool-buttons button.active {  \n  border-color: #DA563A;\n}\n\n/* История действий */\n.history-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.history-buttons button {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 14px;\n}\n\n.history-buttons button:hover:not(:disabled) {\n  background: #e9e9e9;\n}\n\n.history-buttons button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Переключатель курсора */\n.cursor-type-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n.cursor-type-buttons button {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 14px;\n  text-align: center;\n  flex-basis: 50%;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n}\n.cursor-type-buttons button svg {\n  margin-right: 10px;\n}\n.cursor-type-buttons button:hover {\n  background: #e9e9e9;\n}\n\n.cursor-type-buttons button.active {\n  border-color: #DA563A;\n}\n\n/* Палитра цветов */\n.color-picker-section {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* Текущий выбранный цвет */\n.current-color-display {\n  width: 30px;\n  height: 30px;\n  display: block;\n  position: relative;\n  border-radius: 50%;\n}\n\n.current-color-display .color-hex {\n  display: none !important;\n}\n\n/* Стандартная палитра (как в браузере) - всегда открыта */\n.standard-color-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.color-palette {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.palette-color {\n  width: 100%;\n  aspect-ratio: 1;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  cursor: pointer;\n  transition: all 0.15s;\n  padding: 0;\n  min-height: 24px;\n  position: relative;\n}\n\n.palette-color:hover {\n  transform: scale(1.1);\n  border-color: #DA563A;\n  box-shadow: 0 2px 6px rgba(0, 123, 255, 0.3);\n  z-index: 1;\n}\n\n.palette-color.active {\n  border-color: #DA563A;\n  border-width: 2px;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\n}\n\n.hue-slider-container {\n  width: 100%;\n  position: relative;\n  margin: 8px 0;\n}\n\n.hue-slider {\n  width: 100%;\n  height: 20px;\n  -webkit-appearance: none;\n  appearance: none;\n  border-radius: 10px;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  background: linear-gradient(to right, \n    #ff0000 0%, #ffff00 17%, #00ff00 33%, \n    #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);\n}\n\n.hue-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: white;\n  border: 2px solid #333;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.hue-slider::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: white;\n  border: 2px solid #333;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.sv-picker {\n  width: 100%;\n  height: 230px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: crosshair;\n  position: relative;\n  overflow: hidden;\n  background-size: 100% 100%, 100% 100%;\n  background-position: 0 0, 0 0;\n  background-repeat: no-repeat;\n}\n\n.sv-picker-indicator {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 2px solid white;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.color-picker-footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.hex-input-container {\n  flex: 1;\n}\n\n.hex-input {\n  width: 100%;\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 13px;\n  text-align: center;\n  text-transform: uppercase;\n  background: #f8f8f8;\n}\n\n.hex-input:focus {\n  outline: none;\n  border-color: #DA563A;\n  background: white;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\n}\n\n.eyedropper-button {\n  width: 36px;\n  height: 36px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  color: #333;\n}\n\n.eyedropper-button:hover {\n  background: #f0f0f0;\n  border-color: #999;\n}\n\n.eyedropper-button:active {\n  background: #e0e0e0;\n  transform: scale(0.95);\n}\n\n.eyedropper-button svg {\n  width: 100%;\n  height: 100%;\n}\n\n/* Размер инструментов */\n.size-control {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.size-control input[type=\"range\"] {\n  width: 100%;\n}\n\n.size-control span {\n  text-align: center;\n  font-size: 12px;\n  color: #666;\n}\n\n/* Масштаб */\n.zoom-control {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.zoom-control input[type=\"range\"] {\n  width: 100%;\n}\n\n.zoom-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.zoom-info span {\n  font-size: 12px;\n  color: #666;\n}\n\n.zoom-info button {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.zoom-info button:hover:not(:disabled) {\n  background: #e9e9e9;\n}\n\n.zoom-info button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Действия */\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.upload-button {\n  display: block;\n  padding: 12px 15px;\n  background: #28a745;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: center;\n  transition: background 0.2s;\n  font-size: 14px;\n  border: none;\n}\n\n.upload-button:hover {\n  background: #218838;\n}\n\n.action-buttons button {\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n  font-size: 14px;\n  text-align: left;\n}\n\n.action-buttons button:hover:not(:disabled) {\n  background: #e9e9e9;\n}\n\n.action-buttons button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Область canvas */\n.canvas-area {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #e9ecef;\n}\n\n.instructions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 12px;\n  flex-shrink: 0;\n  border-left: 1px solid #DBDBDB;\n  margin:0 2vw;\n}\n.instructions-block {\n  padding: 10px 1.5vw;\n  border-right: 1px solid #DBDBDB;\n  color: #999;\n}\n.instructions-block span {\n  color: #000;\n}\n\n.canvas-container {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  background: #f0f0f0;\n}\n\n.canvas-container canvas {\n  display: block;\n  background: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border: 1px solid #ccc;\n  /* Размеры canvas устанавливаются программно, CSS не должен их изменять */\n}\n\n.placeholder {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #666;\n  font-size: 18px;\n  text-align: center;\n  pointer-events: auto;\n  background: rgba(255, 255, 255, 0.95);\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px dashed #DA563A;\n}\n\n.placeholder:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: #0056b3;\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);\n  transform: translate(-50%, -50%) scale(1.02);\n}\n\n.custom-slider {\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent; /* Remove default background */\n  width: 100%;\n}\n.custom-slider::-webkit-slider-runnable-track {\n  background: #ddd; /* Color of the track */\n  height: 8px;\n  border-radius: 4px;\n}\n.custom-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%; /* Circular thumb */\n  background: #DA563A; /* Color of the thumb */\n  cursor: pointer;\n  margin-top: -6px; /* Center the thumb vertically */\n}\n\n/* Mozilla Firefox */\n.custom-slider::-moz-range-track {\n  background: #ddd; /* Color of the track */\n  height: 8px;\n  border-radius: 4px;\n}\n\n.custom-slider::-moz-range-thumb {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%; /* Circular thumb */\n  background: #DA563A; /* Color of the thumb */\n  cursor: pointer;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .app-layout {\n    flex-direction: column;\n  }\n\n  .left-sidebar {\n    width: 100%;\n    min-width: 100%;\n    max-height: 50vh;\n    border-right: none;\n    border-bottom: 2px solid #ddd;\n  }\n\n  .toolbar {\n    padding: 10px;\n  }\n\n  .tool-buttons {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .tool-buttons button {\n    flex: 1;\n    min-width: 100px;\n  }\n\n  .color-palette {\n    grid-template-columns: repeat(10, 1fr);\n  }\n\n  .action-buttons {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .action-buttons button,\n  .upload-button {\n    flex: 1;\n    min-width: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
